export const DEFAULT_ERROR_MESSAGE = "Something went wrong, please try again.";

export enum ErrorCode {
  UnknownError = "UnknownError",
  InvalidReferralCode = "InvalidReferralCode",
  InvalidBSB = "InvalidBSB",
  QuoteLocked = "QuoteLocked",
  QuoteDeleted = "QuoteDeleted",
  CatcheServiceUnavailable = "CatcheServiceUnavailable",
  NotFoundError = "NotFoundError",
}

export const ErrorCodeMap: Record<ErrorCode, string> = {
  UnknownError: DEFAULT_ERROR_MESSAGE,
  InvalidReferralCode: "Referral code is not valid.",
  InvalidBSB: "The provided BSB is not valid.",
  QuoteLocked: "Quote is locked and cannot be updated.",
  QuoteDeleted: "Quote is deleted and cannot be viewed.",
  CatcheServiceUnavailable:
    "System maintenance in progress. Please try again in 1 hour.",
  NotFoundError: "The page you are looking for does not exist.",
};
